module.exports = __webpack_public_path__ + "img/hackernoon.7ddabcae.png";